// config.js

const config = {
    serverUrl: process.env.REACT_APP_SERVER_URL || 'https://tangiblee-3d.eastus.cloudapp.azure.com/render-service',
    appUrl: "https://tangiblee-3d.eastus.cloudapp.azure.com/",
    // productsServerUrl: 'http://localhost:8003'
    productUrl: 'https://tangiblee-3d.eastus.cloudapp.azure.com/render-service/products/',
    searchUrl: 'https://tangiblee-3d.eastus.cloudapp.azure.com/search-service/search-products/',
    productJsonUrl: 'https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/videos/',
}

export default config;